import { api } from '@moxiltd/moxijs/src/api/api.ts';

const getTeamSection = () => document.getElementById('team-section');

const createTeamMember = ({
    name, image, text1, text2, email,
}) => {
    let infoLine1 = '';
    let infoLine2 = '<br/>';

    if (text1.length !== 0) {
        infoLine1 = `<span class="info-line">${text1}</span>`;
    }

    if (text2.length !== 0) {
        infoLine2 = `<span class="info-line">${text2}</span>`;
    }

    let imageTag;

    if (image !== null) {
        imageTag = `<div class="img-container">
                       <img src="${window.baseUrl}${image.filepath}"/>
                   </div>`;
    } else {
        imageTag = `<div class="img-container" style="background-color: black;"></div>`;
    }

    return `<div class="team-member">
                ${imageTag}
                <h4 class="name">${name}</h4>
                ${infoLine1}
                ${infoLine2}
                <a class="email" href="mailto:${email}">${email}</a>
            </div>`;
};


const clearResults = () => {
    const teamContainer = getTeamSection().querySelector('.team-container');
    while (teamContainer.lastElementChild) {
        teamContainer.removeChild(teamContainer.lastElementChild);
    }
};

export function fetchTeamCategory(category) {
    clearResults();
    getTeamSection().querySelector('.spinner').classList.add('show');
    const request = api.api_get(`${window.baseUrl}api/team/${category}?lang=${window.lang}`);
    request.then((response) => {
        const teamMembers = response.data
            .map((x) => createTeamMember(x))
            .map((x) => `<div class="column is-4">${x}</div>`)
            .reduce((x, y) => x + y, '');

        getTeamSection().querySelector('.spinner').classList.remove('show');
        getTeamSection().querySelector('.team-container').innerHTML = teamMembers;
    });
}

if (getTeamSection()) {
    fetchTeamCategory('board');
    document.querySelectorAll('.category-button').forEach(x => {
        x.addEventListener('click', e => {
            const category = e.target.dataset.category;

            document.querySelectorAll('.category-button').forEach(x => {
                x.classList.remove('active');
            });

            e.target.classList.add('active');
            document.querySelector('.team.section.team .subtitle').innerText = moxi.i18n.t('general.' + category);
            fetchTeamCategory(category);
        });
    });
}
